import { ConversationReportsCard, EscalationWebhookCard } from "@/components/agent/details";
import { CoreDrawer } from "@/components/common/CoreDrawer";
import { Agent } from "@/types/agent/agent";

interface NotificationsDrawerProps {
  genie: Agent;
  isOpen: boolean;
  onClose: () => void;
}

export default function NotificationsDrawer({ genie, isOpen, onClose }: NotificationsDrawerProps) {
  const brand = genie.branding?.primaryColor ?? "#4E9CFF";

  return (
    <CoreDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Notifications"
      description="Configure conversation reports and escalation alerts for your genie."
    >
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 xl:items-stretch">
        <ConversationReportsCard agent={genie} brand={brand} />
        <EscalationWebhookCard agent={genie} brand={brand} />
      </div>
    </CoreDrawer>
  );
}
